/* eslint jsx-a11y/no-static-element-interactions: "off", no-restricted-syntax: "off", guard-for-in: "off" */

import React, { Component } from "react";
import Link from "react-router/Link";
import { Card, CardHeader, CardTitle, CardText } from "material-ui/Card";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import CircularProgress from "material-ui/CircularProgress";
import Divider from "material-ui/Divider";

import { loginUser } from "../actions/actions";
import apiErrors from "../modules/apierrors";
import getErrors from "../modules/geterrors";

/*
 * Login has one responsibility - pass the credentials on to an action creator.
 *
 * The UI should reflect state and display error messages to guide the user.
 *
 * isFetching - show spinner and disable form
 *
 *
 **/
class Login extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      password: "",
      remember: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { auth } = this.props;

    if (
      auth.isAuthenticated === false &&
      nextProps.auth.isAuthenticated === true
    ) {
      this.setState({ email: "", password: "" });
    }
  }

  handleCheck = (event, isChecked) => {
    this.setState({ remember: isChecked });
  };

  handleForm = event => {
    event.preventDefault();
    const state = { ...this.state };
    state.email = this.emailInput.getValue();
    state.password = this.passwordInput.getValue();

    this.setState({ ...state });
  };

  handleClick(event) {
    event.preventDefault();
    const email = this.state.email.trim();
    const password = this.state.password.trim();
    const remember = this.state.remember;
    const creds = { email, password, remember };
    this.props.dispatch(loginUser(creds));
  }

  render() {
    const { auth } = this.props;
    const disabled = auth.isFetching;
    const submitDisabled =
      this.state.email.length < 4 || this.state.password.length < 6;

    const { errorMessages, validationErrors } = getErrors(auth.errors);
    const emailErrorMessage =
      apiErrors[validationErrors.email] || validationErrors.email;
    const passwordErrorMessage =
      apiErrors[validationErrors.password] || validationErrors.password;

    const label = auth.isFetching ? <CircularProgress size={20} /> : "Login";
    return (
      <Card key="login">
        <CardHeader title="Login to Pronounce Live" />
        <div className="pronounce-login">
          <CardText>
            <form onSubmit={event => this.handleClick(event)}>
              <TextField
                autoFocus
                onChange={this.handleForm}
                disabled={disabled}
                ref={input => {
                  this.emailInput = input;
                }}
                errorText={emailErrorMessage}
                type="text"
                name="email"
                placeholder="email"
                min="4"
                max="100"
              />{" "}
              <br />
              <TextField
                onChange={this.handleForm}
                disabled={disabled}
                ref={input => {
                  this.passwordInput = input;
                }}
                errorText={passwordErrorMessage}
                type="password"
                name="password"
                placeholder="password"
                min="6"
                max="100"
              />
              <br />
              <Checkbox
                label="Remember me"
                checked={this.state.remember}
                onCheck={this.handleCheck}
              />
              <FlatButton
                type="submit"
                disabled={submitDisabled}
                onClick={event => this.handleClick(event)}
                label={label}
              />
            </form>
          </CardText>
          <CardText>
            {errorMessages.map((error, index) => (
              <div key={index}>
                <strong>{error}</strong>
              </div>
            ))}
          </CardText>

          <CardText>
            <span onClick={this.props.handleClose}>
              <Link to="/password/email">Forgot password</Link>
            </span>
          </CardText>
        </div>
        <Divider />
        <CardTitle>No account yet? Interested in a subscription?</CardTitle>
        <CardText>
          If you have a group token,{" "}
          <span onClick={this.props.handleClose}>
            <Link to="/register">register here</Link>
          </span>
          .
        </CardText>
      </Card>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js